import React from "react"
import { MdOutlineInsertDriveFile, MdSchedule } from "react-icons/md"
import styles from "./mediaPending.module.css"

const MediaPending = ({ compact = false }) => (
    <div
        className={`${styles.container} ${compact ? styles.compact : ""}`}
        role="group"
        aria-label="Mídia pendente. Aguardando o WhatsApp disponibilizar o arquivo do histórico."
    >
        <span className={styles.icon} aria-hidden="true"><MdOutlineInsertDriveFile /></span>
        <div className={styles.content}>
            <strong>Mídia do histórico</strong>
            <span className={styles.status}><MdSchedule aria-hidden="true" /> Aguardando o WhatsApp</span>
            {!compact && <p>O arquivo ainda não foi disponibilizado. Se recebido, aparecerá aqui automaticamente.</p>}
        </div>
    </div>
)

export default MediaPending
